import * as Types from './types';
import { TSelectOptions } from '../../types';

export const getSelectDataByTimestamp = (type: Types.TSelectType, timestamp?: number): string => {
    if (!timestamp) {
        return '';
    }

    const date = new Date(timestamp);

    switch (type) {
        case 'day':
            return String(date.getDate());

        case 'month':
            return String(date.getMonth());

        case 'year':
            return String(date.getFullYear());

        default:
            return '';
    }
};

export const getSelectDayValue = (options: Types.IGetSelectDayValueOptions): string => {
    const { stateSelectDayValue, stateSelectMonthValue, stateSelectYearValue } = options;

    if (!stateSelectDayValue) {
        return '';
    }

    if (!stateSelectMonthValue) {
        return stateSelectDayValue;
    }

    const date = new Date(Number(stateSelectYearValue) || 1970, Number(stateSelectMonthValue) + 1, 0);
    const maxMonthDay = date.getDate();

    return maxMonthDay >= Number(stateSelectDayValue) ? stateSelectDayValue : '1';
};

export const getSelectDayOptions = (options: Types.IGetSelectDayOptions): TSelectOptions => {
    const { timestamp, stateSelectMonthValue, stateSelectYearValue } = options;
    const days: TSelectOptions = [];
    let date: Date;
    let month: number;

    // if data picker value is not set and month is not set either
    // we need to put some default values to select
    // getting january as it always has 31 days
    if (!timestamp && !stateSelectMonthValue) {
        month = 0;
        date = new Date(1970, month, 1);
    // if data picker value is not set but month has been set already
    // we need to get days for that month (e.g Feb has 28~29 days)
    } else if (!timestamp) {
        month = Number(stateSelectMonthValue);
        date = new Date(Number(stateSelectYearValue) || 1970, month, 1);
    // if data picker has a value we just need to get days according to it
    } else {
        date = new Date(timestamp);
        date.setDate(1);
        month = date.getMonth();
    }

    // Pushing days until month is not changed
    while (date.getMonth() === month) {
        days.push({
            key: date.getDate(),
            value: String(date.getDate()),
            label: String(date.getDate()).padStart(2, '0')
        });

        date.setDate(date.getDate() + 1);
    }

    return days;
};

export const getSelectMonthOptions = (): TSelectOptions => {
    const result = [];

    for (let i = 0; i <= 11; i++) {
        result.push({
            key: i,
            value: String(i),
            label: String(i + 1).padStart(2, '0')
        });
    }

    return result;
};

export const getSelectYearOptions = (yearRange: Types.TYearRange, yearRangeNumber: number): TSelectOptions => {
    const result = [];
    const date = new Date();
    const currentYear = date.getFullYear();

    for (let i = 0; i < yearRangeNumber; i++) {
        const year = yearRange === 'future' ? currentYear + i : currentYear - i;

        result.push({
            key: year,
            value: String(year),
            label: String(year)
        });
    }

    return result;
};
